import React from 'react';

import {
  LatestArticles,
} from '../../../components';

import './style.scss';

const ParagraphLatestMunicipalityArticles = ({ id, entity }) => {

  return (
    <LatestArticles
      id={id}
      entity={entity}
      isForMunicipalities
    />
  );
};

export default ParagraphLatestMunicipalityArticles;
